import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
// import { FrontOfficeComponent } from './views/front-office/front-office.component';
// import { ViennaCodificationReportComponent } from './views/vienna-codification/vienna-codification-report/vienna-codification-report.component';
// import { ViennaCodificationEntryComponent } from './views/vienna-codification/vienna-codification-entry/vienna-codification-entry.component';
// import { ExaminationCopyrightNocComponent } from './views/examination-copyright-noc/examination-copyright-noc.component';
// import { RenewalComponent } from './views/renewal/renewal.component';
// import { RegalCellComponent } from './views/regal-cell/regal-cell.component';
// import { LegalCertificateComponent } from './views/legal-certificate/legal-certificate.component';
// import { EdpAgentManagementComponent } from './views/edp-agent-management/edp-agent-management.component';
// import { AgentManagementExaminationComponent } from './views/agent-management-examination/agent-management-examination.component';
// import { WellknownSupervisorComponent } from './views/wellknown-supervisor/wellknown-supervisor.component';
// import { WellknownTribunalRemarksComponent } from './views/wellknown-tribunal-remarks/wellknown-tribunal-remarks.component';
// import { AgentmanagementSupervisorComponent } from './views/agentmanagement-supervisor/agentmanagement-supervisor.component';
import { AppCustomPreloader } from './app-routing-loader';
import { DirectAccessGuard } from './services/common/direct-access-guard.service';

const routes: Routes = [
    {
        path: '', redirectTo: '/Login', pathMatch: 'full'
    },

    {
        path: 'Login',
        loadChildren: './modules/login/login.module#LoginModule',

        // component: LoginComponent
    },
    {
        path: 'Home',
        data: { preload: false },
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
        // canActivate: [DirectAccessGuard]
    },
    {
        path: 'Dashboard-2',
        data: { preload: false },
        loadChildren: './modules/dashboard-v2/dashboard-v2.module#DashboardV2Module',
        // canActivate: [DirectAccessGuard]
    },
    {
        path: 'application-approval-individual',
        data: { preload: false },
        loadChildren: './modules/application-approval-individual/application-approval-individual.module#ApplicationApprovalIndividualModule',
    },
    {
        path: 'individual-application-view',
        data: { preload: false },
        loadChildren: './modules/individual-application-view/individual-application-view.module#IndividualApplicationViewModule',
    },

    {
        path: 'lending-bank-application-approval-individual',
        data: { preload: false },
        loadChildren: './modules/bank-linkage-individual/bank-linkage-individual.module#BankLinkageIndividualModule',
    },

    {
        path: 'ho-lending-bank-application-approval-individual',
        data: { preload: false },
        loadChildren: './modules/ho-bank-linkage-individual/ho-bank-linkage-individual.module#HoBankLinkageIndividualModule',
    },

    {
        path: 'financial-head-branch',
        data: { preload: false },
        loadChildren: './modules/financial-head-branch/financial-head-branch.module#FinancialHeadBranchModule',
    },

    {
        path: 'lending-branch',
        data: { preload: false },
        loadChildren: './modules/lending-branch-view/lending-branch-view.module#LendingBranchViewModule',
    },
    {
        path: 'approved-lending-bank-view',
        data: { preload: false },
        loadChildren: './modules/approved-lending-bank-view/approved-lending-bank-view.module#ApprovedLendingBankViewModule',
    },

    {
        path: 'subsidy-update-state',
        data: { preload: false },
        loadChildren: './modules/subsidy-status-update/subsidy-status-update.module#SubsidyStatusUpdateModule',
    },
    {
        path: 'nodal-bank-details',
        data: { preload: false },
        loadChildren: './modules/nodal-bank-process/nodal-bank-process.module#NodalBankProcessModule',
    },
    {
        path: 'loan-disbursement',
        data: { preload: false },
        loadChildren: './modules/loan-release-details/loan-release-details.module#LoanReleaseDetailsModule',
    },

    {
        path: 'online-submission',
        data: { preload: false },
        loadChildren: './modules/online-submission/online-submission.module#OnlineSubmissionModule',
    },
    {
        path: 'Profile',
        data: { preload: false },
        loadChildren: './modules/profile/profile.module#ProfileModule',
    },

    {
        path: 'user-management',
        data: { preload: false },
        loadChildren: './modules/user-management-view/user-management-view.module#UserManagementViewModule',
    },


    {
        path: 'reports',
        data: { preload: false },
        loadChildren: './modules/reports-view/reports-view.module#ReportsViewModule'
    },

    {
        path: 'lending-bank-reports',
        data: { preload: false },
        loadChildren: './modules/lending-bank-report-view/lending-bank-report-view.module#LendingBankReportViewModule'
    },
    {
        path: 'lending-bank-reports-v2',
        data: { preload: false },
        loadChildren: './modules/lending-bank-report-v2-view/lending-bank-report-v2-view.module#LendingBankReportV2ViewModule'
    },

    {
        path: 'Grievance',
        data: { preload: false },
        loadChildren: './modules/grievance-view/grievance-view.module#GrievanceViewModule'
    },

    {
        path: 'manage-role',
        data: { preload: false },
        loadChildren: './modules/manage-role-view/manage-role-view.module#ManageRoleViewModule'
    },

    {
        path: 'shg-approval',
        data: { preload: false },
        loadChildren: './modules/approval-non-individual-shg-view/approval-non-individual-shg-view.module#ApprovalNonIndividualShgViewModule'
    },

    {
        path: 'fpc-approval',
        data: { preload: false },
        loadChildren: './modules/approval-non-individual-fpc-view/approval-non-individual-fpc-view.module#ApprovalNonIndividualFpcViewModule'
    },

    {
        path: 'cooperative-approval',
        data: { preload: false },
        loadChildren: './modules/approval-non-individual-cooperative-view/approval-non-individual-cooperative-view.module#ApprovalNonIndividualCooperativeViewModule'
    },
    {
        path: 'common-infrastructure-approval',
        data: { preload: false },
        loadChildren: './modules/approval-non-individual-common-infra-view/approval-non-individual-common-infra-view.module#ApprovalNonIndividualCommonInfraViewModule'
    },


    {
        path: 'approval-non-individual',
        data: { preload: false },
        loadChildren: './modules/approval-non-individual-common-view/approval-non-individual-common-view.module#ApprovalNonIndividualCommonViewModule'
    },
    {
        path: 'non-individual-bank-linkage',
        data: { preload: false },
        loadChildren: './modules/non-individual-bank-linkage-view/non-individual-bank-linkage-view.module#NonIndividualBankLinkageViewModule'
    },
    {
        path: 'ho-non-individual-bank-linkage',
        data: { preload: false },
        loadChildren: './modules/ho-non-individual-bank-linkage-view/ho-non-individual-bank-linkage-view.module#HoNonIndividualBankLinkageViewModule'
    },

    {
        path: 'reset-password',
        data: { preload: false },
        loadChildren: './modules/user-mgmt-reset-pwd-view/user-mgmt-reset-pwd-view.module#UserMgmtResetPwdViewModule'
    },

    {
        path: 'bank-linkage-state',
        data: { preload: false },
        loadChildren: './modules/bank-linkage-state-view/bank-linkage-state-view.module#BankLinkageStateViewModule'
    },


    {
        path: 'nodal-bank-status',
        data: { preload: false },
        loadChildren: './modules/nodal-bank-status-view/nodal-bank-status-view.module#NodalBankStatusViewModule',
    },

    {
        path: 'proposed-product-report',
        data: { preload: false },
        loadChildren: './modules/proposed-product-report/proposed-product-report.module#ProposedProductReportModule',
    },


    {
        path: 'proposed-business-report',
        data: { preload: false },
        loadChildren: './modules/proposed-business-report/proposed-business-report.module#ProposedBusinessReportModule',
    },

    {
        path: 'application-financial-information-report',
        data: { preload: false },
        loadChildren: './modules/application-financial-info-reportor/application-financial-info-reportor.module#ApplicationFinancialInfoReportorModule',
    },

    {
        path: 'defficiency-letter-dlc-report',
        data: { preload: false },
        loadChildren: './modules/defficiency-letter-dlc-report-view/defficiency-letter-dlc-report-view.module#DefficiencyLetterDlcReportViewModule',
    },


    {
        path: 'state-wise-applicant-profile-report',
        data: { preload: false },
        loadChildren: './modules/state-wise-applicant-profile-view/state-wise-applicant-profile-view.module#StateWiseApplicantProfileViewModule',
    },


    {
        path: 'most-prefered-bank-approved-applicant',
        data: { preload: false },
        loadChildren: './modules/most-prefered-bank-approved-applicant-view/most-prefered-bank-approved-applicant-view.module#MostPreferedBankApprovedApplicantViewModule',
    },

    {
        path: 'subsidy-amount-not-submited-state',
        data: { preload: false },
        loadChildren: './modules/subsidy-not-submited-report-view/subsidy-not-submited-report-view.module#SubsidyNotSubmitedReportViewModule',
    },


    {
        path: 'loan-rejected-both-bank',
        data: { preload: false },
        loadChildren: './modules/loan-rejected-both-bank-view/loan-rejected-both-bank-view.module#LoanRejectedBothBankViewModule',
    },

    {
        path: 'loan-approved-second-bank',
        data: { preload: false },
        loadChildren: './modules/loan-approved-second-preferred-bank-view/loan-approved-second-preferred-bank-view.module#LoanApprovedSecondPreferredBankViewModule',
    },

    {
        path: 'grievance-resolved-issues',
        data: { preload: false },
        loadChildren: './modules/grievance-resolved-issues-view/grievance-resolved-issues-view.module#GrievanceResolvedIssuesViewModule',
    },

    {
        path: 'beneficiary-loan-tracking',
        data: { preload: false },
        loadChildren: './modules/beneficiary-loan-tracking-view/beneficiary-loan-tracking-view.module#BeneficiaryLoanTrackingViewModule',
    },

    {
        path: 'drp-performance-report',
        data: { preload: false },
        loadChildren: './modules/drp-performance-report-view/drp-performance-report-view.module#DrpPerformanceReportViewModule',
    },

    {
        path: 'grievance-not-resolved-no-action-taken',
        data: { preload: false },
        loadChildren: './modules/grev-not-resolved-no-action-view/grev-not-resolved-no-action-view.module#GrevNotResolvedNoActionViewModule',
    },

    {
        path: 'fund-monitoring',
        data: { preload: false },
        loadChildren: './modules/fund-monitoring-view/fund-monitoring-view.module#FundMonitoringViewModule',
    },

    {
        path: 'performance-monitoring',
        data: { preload: false },
        loadChildren: './modules/performance-monitoring-view/performance-monitoring-view.module#PerformanceMonitoringViewModule',
    },

    {
        path: 'guidelines-instructions',
        data: { preload: false },
        loadChildren: './modules/guidelines-instruction-view/guidelines-instruction-view.module#GuidelinesInstructionViewModule',
    },

    {
        path: 'status-update-mofpi',
        data: { preload: false },
        loadChildren: './modules/status-update-mofpi-view/status-update-mofpi-view.module#StatusUpdateMofpiViewModule',
    },

    {
        path: 'loan-emi-repayment-report',
        data: { preload: false },
        loadChildren: './modules/fundm-loanemi-repayment-report-view/fundm-loanemi-repayment-report-view.module#FundmLoanemiRepaymentReportViewModule',
    },

    {
        path: 'total-certificate-report',
        data: { preload: false },
        loadChildren: './modules/fundm-total-certificate-report-view/fundm-total-certificate-report-view.module#FundmTotalCertificateReportViewModule',
    },

    {
        path: 'total-investment-report',
        data: { preload: false },
        loadChildren: './modules/fundm-total-investment-report-view/fundm-total-investment-report-view.module#FundmTotalInvestmentReportViewModule',
    },

    {
        path: 'total-sales-report',
        data: { preload: false },
        loadChildren: './modules/fundm-total-sales-report-view/fundm-total-sales-report-view.module#FundmTotalSalesReportViewModule',
    },

    {
        path: 'loan-defaulters-report',
        data: { preload: false },
        loadChildren: './modules/fundm-loan-defaulters-report-view/fundm-loan-defaulters-report-view.module#FundmLoanDefaultersReportViewModule',
    },

    {
        path: 'applicants-number-loan-repayment-report',
        data: { preload: false },
        loadChildren: './modules/fundm-number-applicant-loan-repayment-report-view/fundm-number-applicant-loan-repayment-report-view.module#FundmNumberApplicantLoanRepaymentReportViewModule',
    },

    {
        path: 'total-workers-report',
        data: { preload: false },
        loadChildren: './modules/fundm-total-workers-report-view/fundm-total-workers-report-view.module#FundmTotalWorkersReportViewModule',
    },


    {
        path: 'total-applications-submitted',
        data: { preload: false },
        loadChildren: './modules/project-monitoring-report-view/project-monitoring-report-view.module#ProjectMonitoringReportViewModule',
    },


    {
        path: 'bank-approved-applications',
        data: { preload: false },
        loadChildren: './modules/bank-approved-applications-report-view/bank-approved-applications-report-view.module#BankApprovedApplicationsReportViewModule',
    },

    {
        path: 'bank-approved-applications-graph',
        data: { preload: false },
        loadChildren: './modules/bank-approved-graph-report-view/bank-approved-graph-report-view.module#BankApprovedGraphReportViewModule',
    },


    {
        path: 'total-subsidy-disbursed',
        data: { preload: false },
        loadChildren: './modules/total-subsidy-disbursed-report-view/total-subsidy-disbursed-report-view.module#TotalSubsidyDisbursedReportViewModule',
    },


    {
        path: 'login-details-report',
        data: { preload: false },
        loadChildren: './modules/login-details-report-view/login-details-report-view.module#LoginDetailsReportViewModule',
    },


    {
        path: 'business-lifecycle-report',
        data: { preload: false },
        loadChildren: './modules/fundm-benificiary-lifecycle-report-view/fundm-benificiary-lifecycle-report-view.module#FundmBenificiaryLifecycleReportViewModule',
    },

    {
        path: 'beneficiary-status-report',
        data: { preload: false },
        loadChildren: './modules/benificiary-status-report-view/benificiary-status-report-view.module#BenificiaryStatusReportViewModule',
    },

    {
        path: 'grievance-count-report',
        data: { preload: false },
        loadChildren: './modules/grievance-count-report-view/grievance-count-report-view.module#GrievanceCountReportViewModule',
    },

    {
        path: 'defficiency-letter-state',
        data: { preload: false },
        loadChildren: './modules/deficiency-letter-by-state-report/deficiency-letter-by-state-report.module#DeficiencyLetterByStateReportModule',
    },

    {
        path: 'loan-outstanding-status',
        data: { preload: false },
        loadChildren: './modules/loan-outstandingstatus/loan-outstandingstatus.module#LoanOutstandingstatusModule',
    },

    {
        path: 'loan-defaulters',
        data: { preload: false },
        loadChildren: './modules/loan-defaulters/loan-defaulters.module#LoanDefaultersModule',
    },
    {
        path: 'loan-sanction-rejection',
        data: { preload: false },
        loadChildren: './modules/loan-sanction-rejection/loan-sanction-rejection.module#LoanSanctionRejectionModule',
    },
    {
        path: 'certifications-standard-achieved',
        data: { preload: false },
        loadChildren: './modules/certifications-standard-achieved/certifications-standard-achieved.module#CertificationsStandardAchievedModule',
    },
    {
        path: 'beneficiary-business-lifecycle',
        data: { preload: false },
        loadChildren: './modules/beneficiary-business-lifecycle/beneficiary-business-lifecycle.module#BeneficiaryBusinessLifecycleModule',
    },
    {
        path: 'beneficiary-business-lifecycle-applicant-type',
        data: { preload: false },
        loadChildren: './modules/beneficiary-business-lifecycle-applicant-type/beneficiary-business-lifecycle-applicant-type.module#BeneficiaryBusinessLifecycleApplicantTypeModule',
    },
    {
        path: 'total-worker-employed-beneficiary',
        data: { preload: false },
        loadChildren: './modules/total-worker-employed-beneficiary/total-worker-employed-beneficiary.module#TotalWorkerEmployedBeneficiaryModule',
    },
    {
        path: 'loan-sanction-rejection-overall-beneficiary',
        data: { preload: false },
        loadChildren: './modules/loan-sanction-rejection-overall-beneficiary/loan-sanction-rejection-overall-beneficiary.module#LoanSanctionRejectionOverallBeneficiaryModule',
    },
    {
        path: 'loan-sanction-rejection-overall-banklevel',
        data: { preload: false },
        loadChildren: './modules/loan-sanction-rejection-overall-banklevel/loan-sanction-rejection-overall-banklevel.module#LoanSanctionRejectionOverallBanklevelModule',
    },
    {
        path: 'beneficiary-sales-report',
        data: { preload: false },
        loadChildren: './modules/beneficiary-sales-report/beneficiary-sales-report.module#BeneficiarySalesReportModule',
    },
    {
        path: 'user-manual',
        data: { preload: false },
        loadChildren: './modules/user-manual/user-manual.module#UserManualModule',
    },

    {
        path: 'application-view',
        data: { preload: false },
        loadChildren: './modules/application-details-section-view/application-details-section-view.module#ApplicationDetailsSectionViewModule',
    },

    {
        path: 'state-pip',
        data: { preload: false },
        loadChildren: './modules/state-pip-view/state-pip-view.module#StatePipViewModule',
    },

    {
        path: 'central-pip',
        data: { preload: false },
        loadChildren: './modules/central-pip-view/central-pip-view.module#CentralPipViewModule',
    },

    {
        path: 'manage-image-gallery',
        data: { preload: false },
        loadChildren: './modules/manage-image-gallery-view/manage-image-gallery-view.module#ManageImageGalleryViewModule',
    },


    {
        path: 'manage-latest-update',
        data: { preload: false },
        loadChildren: './modules/manage-latest-update-view/manage-latest-update-view.module#ManageLatestUpdateViewModule',
    },

    {
        path: 'manage-slup-studies',
        data: { preload: false },
        loadChildren: './modules/manage-slup-studies-view/manage-slup-studies-view.module#ManageSlupStudiesViewModule',
    },

    {
        path: 'manage-contact-details',
        data: { preload: false },
        loadChildren: './modules/manage-contact-details-view/manage-contact-details-view.module#ManageContactDetailsViewModule',
    },

    {
        path: 'manage-whats-new',
        data: { preload: false },
        loadChildren: './modules/manage-whats-new-view/manage-whats-new-view.module#ManageWhatsNewViewModule',
    },
    {
        path: 'manage-important-links',
        data: { preload: false },
        loadChildren: './modules/manage-important-links-view/manage-important-links-view.module#ManageImportantLinksViewModule',
    },
    {
        path: 'manage-media-links',
        data: { preload: false },
        loadChildren: './modules/manage-media-links-view/manage-media-links-view.module#ManageMediaLinksViewModule',
    },

    {
        path: 'manage-odop',
        data: { preload: false },
        loadChildren: './modules/manage-odop-view/manage-odop-view.module#ManageOdopViewModule',
    },
    {
        path: 'upload-sample-product-dpr',
        data: { preload: false },
        loadChildren: './modules/upload-sample-product-dpr-view/upload-sample-product-dpr-view.module#UploadSampleProductDprViewModule',
    },
    {
        path: 'success-stories-detail',
        data: { preload: false },
        loadChildren: './modules/success-stories-detail-view/success-stories-detail-view.module#SuccessStoriesDetailViewModule',
    },

    {
        path: 'manage-website-links',
        data: { preload: false },
        loadChildren: './modules/manage-website-links-view/manage-website-links-view.module#ManageWebsiteLinksViewModule',
    },


    {
        path: 'manage-banner-images',
        data: { preload: false },
        loadChildren: './modules/manage-banner-images-view/manage-banner-images-view.module#ManageBannerImagesViewModule',
    },

    {
        path: 'incubation-centre-report',
        data: { preload: false },
        loadChildren: './modules/incubation-centre-report/incubation-centre-report.module#IncubationCentreReportModule',
    },

    {
        path: 'incubation-centre-details-report',
        data: { preload: false },
        loadChildren: './modules/incubation-centre-details-report-view/incubation-centre-details-report-view.module#IncubationCentreDetailsReportViewModule',
    },

    {
        path: 'content-management',
        data: { preload: false },
        loadChildren: './modules/manage-lms-content-management-view/manage-lms-content-management-view.module#ManageLmsContentManagementViewModule',
    },

    {
        path: 'content-creation',
        data: { preload: false },
        loadChildren: './modules/manage-lms-content-approver-view/manage-lms-content-approver-view.module#ManageLmsContentApproverViewModule',
    },

    {
        path: 'course-creation',
        data: { preload: false },
        loadChildren: './modules/manage-lms-course-creation-view/manage-lms-course-creation-view.module#ManageLmsCourseCreationViewModule',
    },


    {
        path: 'draft-applications',
        data: { preload: false },
        loadChildren: './modules/draft-applications-view/draft-applications-view.module#DraftApplicationsViewModule',
    },

    {
        path: 'rollback-decision',
        data: { preload: false },
        loadChildren: './modules/rollback-decision-view/rollback-decision-view.module#RollbackDecisionViewModule',
    },

    {
        path: 'training-creation',
        data: { preload: false },
        loadChildren: './modules/training-creation-view/training-creation-view.module#TrainingCreationViewModule',
    },

    {
        path: 'direct-enrollment',
        data: { preload: false },
        loadChildren: './modules/direct-enrollment-view/direct-enrollment-view.module#DirectEnrollmentViewModule',
    },

    {
        path: 'result-update',
        data: { preload: false },
        loadChildren: './modules/result-update-view/result-update-view.module#ResultUpdateViewModule',
    },

    {
        path: 'update-training-record',
        data: { preload: false },
        loadChildren: './modules/update-training-records-view/update-training-records-view.module#UpdateTrainingRecordsViewModule',
    },


    {
        path: 'training-commencement',
        data: { preload: false },
        loadChildren: './modules/training-commencement-view/training-commencement-view.module#TrainingCommencementViewModule',
    },

    {
        path: 'view-trainings',
        data: { preload: false },
        loadChildren: './modules/view-trainings-view/view-trainings-view.module#ViewTrainingsViewModule',
    },


    {
        path: 'sna-slti-trainings',
        data: { preload: false },
        loadChildren: './modules/sna-slti-trainings-view/sna-slti-trainings-view.module#SnaSltiTrainingsViewModule',
    },


    {
        path: 'master-trainer-registration',
        data: { preload: false },
        loadChildren: './modules/master-trainer-registration-view/master-trainer-registration-view.module#MasterTrainerRegistrationViewModule',
    },


    {
        path: 'trainer-approval',
        data: { preload: false },
        loadChildren: './modules/trainer-approval-view/trainer-approval-view.module#TrainerApprovalViewModule',
    },


    {
        path: 'detailed-content-report',
        data: { preload: false },
        loadChildren: './modules/detailed-content-report-view/detailed-content-report-view.module#DetailedContentReportViewModule',
    },


    {
        path: 'content-expenditure',
        data: { preload: false },
        loadChildren: './modules/content-expenditure-report-view/content-expenditure-report-view.module#ContentExpenditureReportViewModule',
    }, {
        path: 'dashboard-3',
        data: { preload: false },
        loadChildren: './modules/dashboard-v3/dashboard-v3.module#DashboardV3Module',
    },
    // {
    //   path: 'Complete-Refusal',
    //   data: { preload: false },
    //   loadChildren: './modules/complete-refusal/complete-refusal.module#CompleteRefusalModule',
    // },
    // {
    //   path: 'Copyright-Noc-Reply-Not-Recieved',
    //   data: { preload: false },
    //   loadChildren: './modules/copyright-noc-reply-not-recieved/copyright-noc-reply-not-recieved.module#CopyrightNocReplyNotRecievedModule',
    // },
    // {
    //   path: 'Madrid-All-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-all-application/madrid-all-application.module#MadridAllApplicationModule',
    // },
    // {
    //   path: 'Certification-International-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/certification-international-application/certification-international-application.module#CertificationInternationalApplicationModule',
    // },
    // {
    //   path: 'Madrid-Upload-International-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-upload-international-application/madrid-upload-international-application.module#MadridUploadInternationalApplicationModule',
    // },
    // {
    //   path: 'Madrid-Ceasing-Effects',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-ceasing-effects/madrid-ceasing-effects.module#MadridCeasingEffectsModule',
    // },
    // {
    //   path: 'Madrid-Forwarded-Mm2-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-forwarded-mm2-application/madrid-forwarded-mm2-application.module#MadridForwardedMm2ApplicationModule',
    // },
    // {
    //   path: 'Madrid-Filed-Mm2-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-filed-mm2-application/madrid-filed-mm2-application.module#MadridFiledMm2ApplicationModule',
    // },
    // {
    //   path: 'Madrid-Pending-Irregularities',
    //   data: { preload: false },
    //   loadChildren: './modules/madrid-pending-irregularities/madrid-pending-irregularities.module#MadridPendingIrregularitiesModule',
    // },
    // {
    //   path: 'IOAI-Irregularities-Disposed',
    //   data: { preload: false },
    //   loadChildren: './modules/complete-refusal/complete-refusal.module#CompleteRefusalModule',
    // },
    // {
    //   path: 'iaoi-irregularties-disposed',
    //   data: { preload: false },
    //   loadChildren: './modules/iaoi-irregularties-disposed/iaoi-irregularties-disposed.module#IaoiIrregulartiesDisposedModule',
    // },
    // {
    //   path: 'Indian-Designation-Import',
    //   data: { preload: false },
    //   loadChildren: './modules/indian-designation-import/indian-designation-import.module#IndianDesignationImportModule',
    // },
    // {
    //   path: 'Process-Application',
    //   data: { preload: false },
    //   loadChildren: './modules/process-application/process-application.module#ProcessApplicationModule',
    // },
    // {
    //   path: 'Process-Irregularities',
    //   data: { preload: false },
    //   loadChildren: './modules/process-irregularities/process-irregularities.module#ProcessIrregularitiesModule',
    // },
    // {
    //   path: 'Grant-of-Protection',
    //   data: { preload: false },
    //   loadChildren: './modules/grant-of-protection/grant-of-protection.module#GrantOfProtectionModule',
    // },
    // {
    //   path: 'Notice-Possible-Opposition',
    //   data: { preload: false },
    //   loadChildren: './modules/notice-possible-opposition/notice-possible-opposition.module#NoticePossibleOppositionModule',
    // },
    // {
    //   path: 'PR-Bases-Opposition',
    //   data: { preload: false },
    //   loadChildren: './modules/pr-based-opposition/pr-based-opposition.module#PrBasedOppositionModule',
    // },
    {
        path: 'add-master-bank',
        data: { preload: false },
        loadChildren: './modules/add-master-bank-view/add-master-bank-view.module#AddMasterBankViewModule',
    }, {
        path: 'edit-master-bank',
        data: { preload: false },
        loadChildren: './modules/edit-master-bank-view/edit-master-bank-view.module#EditMasterBankViewModule',
    }, {
        path: 'add-bank-branch',
        data: { preload: false },
        loadChildren: './modules/add-bank-branch-view/add-bank-branch-view.module#AddBankBranchViewModule',
    },
    {
        path: 'edit-bank-branch',
        data: { preload: false },
        loadChildren: './modules/edit-bank-branch-view/edit-bank-branch-view.module#EditBankBranchViewModule',
    },
    {
        path: 'edit-application-details',
        data: { preload: false },
        loadChildren: './modules/edit-application-details-view/edit-application-details-view.module#EditApplicationDetailsViewModule',
    },
    {
        path: 'internal-dashboard',
        data: { preload: false },
        loadChildren: './modules/internal-dashboard-view/internal-dashboard-view.module#InternalDashboardViewModule',
    },
    {
        path: 'media-publish',
        data: { preload: false },
        loadChildren: './modules/media-publish-view/media-publish-view.module#MediaPublishViewModule',
    },
    {
        path: 'media-upload',
        data: { preload: false },
        loadChildren: './modules/media-upload-view/media-upload-view.module#MediaUploadViewModule',
    },
    {
        path: 'add-whos-who',
        data: { preload: false },
        loadChildren: './modules/add-whos-who-view/add-whos-who-view.module#AddWhosWhoViewModule',
    },
    {
        path: 'publish-whos-who',
        data: { preload: false },
        loadChildren: './modules/publish-whos-who-view/publish-whos-who-view.module#PublishWhosWhoViewModule',
    },
    {
        path: 'list-whos-who',
        data: { preload: false },
        loadChildren: './modules/list-whos-who-view/list-whos-who-view.module#ListWhosWhoViewModule',
    }, {
        path: 'activate-user',
        data: { preload: false },
        loadChildren: './modules/activate-user-view/activate-user-view.module#ActivateUserViewModule',
    },
    {
        path: 'drp-management',
        data: { preload: false },
        loadChildren: './modules/drp-management-view/drp-management-view.module#DrpManagementViewModule',
    },
    {
        path: 'add-new-build',
        data: { preload: false },
        loadChildren: './modules/add-new-build-view/add-new-build-view.module#AddNewBuildViewModule',
    },
    {
        path: 'all-build-releases',
        data: { preload: false },
        loadChildren: './modules/all-build-releases-view/all-build-releases-view.module#AllBuildReleasesViewModule',
    },
    {
        path: 'approve-drp',
        data: { preload: false },
        loadChildren: './modules/approve-drp-view/approve-drp-view.module#ApproveDrpViewModule',
    }, {
        path: 'formalisation-report',
        data: { preload: false },
        loadChildren: './modules/formalisation-report-view/formalisation-report-view.module#FormalisationReportViewModule',
    },
    {
        path: 'Build-and-Releases',
        data: { preload: false },
        loadChildren: './modules/build/build.module#BuildModule',
    }, {
        path: 'sms-dashboard',
        data: { preload: false },
        loadChildren: './modules/sms-dashboard-view/sms-dashboard-view.module#SmsDashboardViewModule',
    }, {
        path: 'edit-sanction-details',
        data: { preload: false },
        loadChildren: './modules/edit-sanction-details-view/edit-sanction-details-view.module#EditSanctionDetailsViewModule',
    }, {
        path: 'ho-edit-sanction-details',
        data: { preload: false },
        loadChildren: './modules/ho-edit-sanction-details-view/ho-edit-sanction-details-view.module#HoEditSanctionDetailsViewModule',
    }, {
        path: 'change-odop',
        data: { preload: false },
        loadChildren: './modules/change-odop-view/change-odop-view.module#ChangeOdopViewModule',
    },
    {
        path: 'add-service-token',
        data: { preload: false },
        loadChildren: './modules/add-service-token-view/add-service-token-view.module#AddServiceTokenViewModule',
    },
    {
        path: 'manage-service-token',
        data: { preload: false },
        loadChildren: './modules/manage-service-token-view/manage-service-token-view.module#ManageServiceTokenViewModule',
    },
    {
        path: 'extend-user-validity',
        data: { preload: false },
        loadChildren: './modules/extend-user-validity-view/extend-user-validity-view.module#ExtendUserValidityViewModule',
    },
    {
        path: 'sanction-but-not-disbursed',
        data: { preload: false },
        loadChildren: './modules/sanction-but-not-disbursed-view/sanction-but-not-disbursed-view.module#SanctionButNotDisbursedViewModule',
    },
    {
        path: 'ho-verification',
        data: { preload: false },
        loadChildren: './modules/ho-verification-view/ho-verification-view.module#HoVerificationViewModule',
    },
    {
        path: 'view-bank-details',
        data: { preload: false },
        loadChildren: './modules/search-ifsc-view/search-ifsc-view.module#SearchIfscViewModule',
    },
    {
        path: 'rollback-disbursement',
        data: { preload: false },
        loadChildren: './modules/rollback-disbursement-view/rollback-disbursement-view.module#RollbackDisbursementViewModule',
    },
    {
        path: 'ho-rollback-disbursement',
        data: { preload: false },
        loadChildren: './modules/ho-rollback-disbursement-view/ho-rollback-disbursement-view.module#HoRollbackDisbursementViewModule',
    },
    {
        path: 'verify-contact-details',
        data: { preload: false },
        loadChildren: './modules/verify-contact-details/verify-contact-details.module#VerifyContactDetailsModule',
    },
    {
        path: 'update-location',
        data: { preload: false },
        loadChildren: './modules/update-location-view/update-location-view.module#UpdateLocationViewModule',
    },

    {
        path: 'ho-loan-disbursement',
        data: { preload: false },
        loadChildren: './modules/ho-loan-release-details/ho-loan-release-details.module#HoLoanReleaseDetailsModule',
    },

    {
        path: 'shift-application',
        data: { preload: false },
        loadChildren: './modules/shift-application-view/shift-application-view.module#ShiftApplicationViewModule',
    },
    {
        path: 'zonal-verification',
        data: { preload: false },
        loadChildren: './modules/zonal-verification-view/zonal-verification-view.module#ZonalVerificationViewModule',
    },
    {
        path: 'multiple-drp',
        data: { preload: false },
        loadChildren: './modules/multiple-drp-view/multiple-drp-view.module#MultipleDrpViewModule',
    },
    {
        path: 'merge-branch',
        data: { preload: false },
        loadChildren: './modules/merge-branch-view/merge-branch-view.module#MergeBranchViewModule',
    },
    {
        path: 'change-transient-account',
        data: { preload: false },
        loadChildren: './modules/change-transient-account-view/change-transient-account-view.module#ChangeTransientAccountViewModule',
    },
    {
        path: 'dfs-view',
        data: { preload: false },
        loadChildren: './modules/dfs-view/dfs-view.module#DfsViewModule',
    },
    {
        path: 'create-horole-bank-view',
        data: { preload: false },
        loadChildren: './modules/create-horole-bank-view/create-horole-bank-view.module#CreateHoroleBankViewModule',
    },
    {
        path: 'subsidy-report-view',
        data: { preload: false },
        loadChildren: './modules/subsidy-report-view/subsidy-report-view.module#SubsidyReportViewModule',
    },
    {
        path: 'varification-location',
        data: { preload: false },
        loadChildren: './modules/varification-location-view/varification-location-view.module#VarificationLocationViewModule',
    },
    {
        path: 'internal-sourcing-view',
        data: { preload: false },
        loadChildren: './modules/internal-sourcing-view/internal-sourcing-view.module#InternalSourcingViewModule',
    },
    {
        path: 'internal-sourcing-list-view',
        data: { preload: false },
        loadChildren: './modules/internal-sourcing-list-view/internal-sourcing-list-view.module#InternalSourcingListViewModule',
    },
    {
        path: 'bank-sanction',
        data: { preload: false },
        loadChildren: './modules/bank-sanction-view/bank-sanction-view.module#BankSanctionViewModule',
    },
    {
        path: 'state-wise-dfs-view',
        data: { preload: false },
        loadChildren: './modules/state-wise-dfs-view/state-wise-dfs-view.module#StateWiseDfsViewModule',
    },
    {
        path: 'sna-reporting-staff-view',
        data: { preload: false },
        loadChildren: './modules/sna-reporting-staff-view/sna-reporting-staff-view.module#SnaReportingStaffViewModule',
    },
    {
        path: 'sna-supporting-staff-non-view',
        data: { preload: false },
        loadChildren: './modules/sna-supporting-staff-non-view/sna-supporting-staff-non-view.module#SnaSupportingStaffNonViewModule',
    },
    {
        path: 'download-lending-bank-report-view',
        data: { preload: false },
        loadChildren: './modules/download-lending-bank-report-view/download-lending-bank-report-view.module#DownloadLendingBankReportViewModule',
    },
    {
        path: 'parked-report',
        data: { preload: false },
        loadChildren: './modules/parked-report-view/parked-report-view.module#ParkedReportViewModule',
    },
    {
        path: 'gati-shakti',
        data: { preload: false },
        loadChildren: './modules/gati-shakti-view/gati-shakti-view.module#GatiShaktiViewModule',
    },
    {
        path: 'additional-document-report',
        data: { preload: false },
        loadChildren: './modules/additional-document-report-view/additional-document-report-view.module#AdditionalDocumentReportViewModule',
    },
    {
        path: 'bank-pending-report',
        data: { preload: false },
        loadChildren: './modules/bank-pending-report-view/bank-pending-report-view.module#BankPendingReportViewModule',
    },
    {
        path: 'sanction-report-view',
        data: { preload: false },
        loadChildren: './modules/sanction-report-view/sanction-report-view.module#SanctionReportViewModule',
    },
    {
        path: 'bank-wise-application-status-view',
        data: { preload: false },
        loadChildren: './modules/bank-wise-application-status-view/bank-wise-application-status-view.module#BankWiseApplicationStatusViewModule',
    },
    {
        path: 'search-created-user',
        data: { preload: false },
        loadChildren: './modules/search-created-user-view/search-created-user-view.module#SearchCreatedUserViewModule',
    },
    {
        path: 'create-batch-view',
        data: { preload: false },
        loadChildren: './modules/create-batch-view/create-batch-view.module#CreateBatchViewModule',
    },
    {
        path: 'edit-batch-view',
        data: { preload: false },
        loadChildren: './modules/edit-batch-view/edit-batch-view.module#EditBatchViewModule',
    },
    {
        path: 'subsidy-process-view',
        data: { preload: false },
        loadChildren: './modules/subsidy-process-view/subsidy-process-view.module#SubsidyProcessViewModule',
    },
    {
        path: 'grant-release',
        data: { preload: false },
        loadChildren: './modules/grant-release-view/grant-release-view.module#GrantReleaseViewModule',
    },
    {
        path: 'grant-release',
        data: { preload: false },
        loadChildren: './modules/grant-release-view/grant-release-view.module#GrantReleaseViewModule',
    },
    {
        path: 'internal-sourcing-list',
        data: { preload: false },
        loadChildren: './modules/int-src-list-view/int-src-list-view.module#IntSrcListViewModule',
    },
    {
        path: 'subsidy-report',
        data: { preload: false },
        loadChildren: './modules/subsidy-data-view/subsidy-data-view.module#SubsidyDataViewModule',
    },
    {
        path: 'monthly-report',
        data: { preload: false },
        loadChildren: './modules/monthly-wise-report-download-view/monthly-wise-report-download-view.module#MonthlyWiseReportDownloadViewModule',
    },
    {
        path: 'conversion-report',
        data: { preload: false },
        loadChildren: './modules/conversion-report-view/conversion-report-view.module#ConversionReportViewModule',
    },
    {
        path: 'aif-report',
        data: { preload: false },
        loadChildren: './modules/aif-report-view/aif-report-view.module#AifReportViewModule',
    },
    {
        path: 'zone-view',
        data: { preload: false },
        loadChildren: './modules/zone-view/zone-view.module#ZoneViewModule',
    },
    {
        path: 'prayas',
        data: { preload: false },
        loadChildren: './modules/prayas/prayas.module#PrayasModule',
    },
    {
        path: 'pullback-document',
        data: { preload: false },
        loadChildren: './modules/pullback-additional-document-view/pullback-additional-document-view.module#PullbackAdditionalDocumentViewModule',
    },
    {
        path: 'additional-bank-report-v2',
        data: { preload: false },
        loadChildren: './modules/additional-bank-report-v2-view/additional-bank-report-v2-view.module#AdditionalBankReportV2ViewModule',
    },
    {
        path: 'individual-report-new',
        data: { preload: false },
        loadChildren: './modules/individual-report-new-view/individual-report-new-view.module#IndividualReportNewViewModule',
    },
    {
        path: 'zone-report',
        data: { preload: false },
        loadChildren: './modules/zone-report-view/zone-report-view.module#ZoneReportViewModule',
    },
    {
        path: 'add-login-contact-details',
        data: { preload: false },
        loadChildren: './modules/add-login-contact-view/add-login-contact-view.module#AddLoginContactViewModule',
    },
    {
        path: 'convergence-dashboard',
        data: { preload: false },
        loadChildren: './modules/nrlm-dashboard-view/nrlm-dashboard-view.module#NrlmDashboardViewModule',
    },
    {
        path: 'bank-report',
        data: { preload: false },
        loadChildren: './modules/bank-report-view/bank-report-view.module#BankReportViewModule',
    },
    {
        path: 'all-verified-application',
        data: { preload: false },
        loadChildren: './modules/get-all-verified-applications-view/get-all-verified-applications-view.module#GetAllVerifiedApplicationsViewModule',
    },
    {
        path: 'all-PendingVerified-application',
        data: { preload: false },
        loadChildren: './modules/get-all-pending-to-verify-applications-view/get-all-pending-to-verify-applications-view.module#GetAllPendingToVerifyApplicationsViewModule',
    },

    {
        path: 'ho-report',
        data: { preload: false },
        loadChildren: './modules/ho-report-view/ho-report-view.module#HoReportViewModule',
    },
    {
        path: 'edit-sanctions-details-data',
        data: { preload: false },
        loadChildren: './modules/edit-sanctions-details-data-view/edit-sanctions-details-data-view.module#EditSanctionsDetailsDataViewModule',
    },
    {
        path: 'edit-sanctioned-but-no-able',
        data: { preload: false },
        loadChildren: './modules/edit-sanctioned-but-no-able-view/edit-sanctioned-but-no-able-view.module#EditSanctionedButNoAbleViewModule',
    },
    {
        path: 'manage-menu',
        data: { preload: false },
        loadChildren: './modules/manage-menu-view/manage-menu-view.module#ManageMenuViewModule',
    },
    {
        path: 'statewise-sent-to-bank',
        data: { preload: false },
        loadChildren: './modules/statewise-stb-view/statewise-stb-view.module#StatewiseStbViewModule',
    },
    {
        path: 'bankwise-rejected',
        data: { preload: false },
        loadChildren: './modules/bank-wise-reject-view/bank-wise-reject-view.module#BankWiseRejectViewModule',
    },
    {
        path: 'statewise-rejected',
        data: { preload: false },
         loadChildren: './modules/statewise-rejected-view/statewise-rejected-view.module#StatewiseRejectedViewModule',
    },
    {
        path: 'bankwise-pending',
        data: { preload: false },
         loadChildren: './modules/bankwise-pending-report-view/bankwise-pending-report-view.module#BankwisePendingReportViewModule',
    },
    {
        path: 'statewise-pending',
        data: { preload: false },
         loadChildren: './modules/statewise-pending-report-view/statewise-pending-report-view.module#StatewisePendingReportViewModule',
    },
    {
        path: 'statewise-sanctioned',
        data: { preload: false },
         loadChildren: './modules/statewise-sanctioned-report-view/statewise-sanctioned-report-view.module#StatewiseSanctionedReportViewModule',
    },
    {
        path: 'bankwise-sanctioned',
        data: { preload: false },
         loadChildren: './modules/bankwise-sanctioned-report-view/bankwise-sanctioned-report-view.module#BankwiseSanctionedReportViewModule',
    },
    {
        path: 'bankwise-sent-to-bank',
        data: { preload: false },
         loadChildren: './modules/bankwise-senttobank-report-view/bankwise-senttobank-report-view.module#BankwiseSenttobankReportViewModule',
    },
    {
        path: 'withdrawn-application-report',
        data: { preload: false },
        loadChildren: './modules/withdrwan-application-report-view/withdrwan-application-report-view.module#WithdrwanApplicationReportViewModule',
    },
    {
        path: 'subsidy-process-request',
        data: { preload: false },
        loadChildren: './modules/subsidy-process-request-view/subsidy-process-request-view.module#SubsidyProcessRequestViewModule',
    },

    {
        path: 'upload-file-nodal-bank',
        data: { preload: false },
        loadChildren: './modules/upload-file-nodal-bank-view/upload-file-nodal-bank-view.module#UploadFileNodalBankViewModule',
    },

    {
        path: 'upload-batch-file-npmu-finance',
        data: { preload: false },
        loadChildren: './modules/upload-batch-file-npmu-finance-view/upload-batch-file-npmu-finance-view.module#UploadBatchFileNpmuFinanceViewModule',
    },

    {
        path: 'view-response-file',
        data: { preload: false },
        loadChildren: './modules/view-response-file-subsidy-view/view-response-file-subsidy-view.module#ViewResponseFileSubsidyViewModule',
    },

    {
        path: 'subsidy-payment-report',
        data: { preload: false },
        loadChildren: './modules/subsidy-payment-report-view/subsidy-payment-report-view.module#SubsidyPaymentReportViewModule',
    },

    {
        path: 'drp-list',
        data: { preload: false },
        loadChildren: './modules/drp-list-view/drp-list-view.module#DrpListViewModule',
    },
    {
        path: '**', redirectTo: '/Login', pathMatch: 'full'
    }

];

@NgModule({
    imports: [
        [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: AppCustomPreloader } // {useHash: true}
        )]
    ],
    declarations: [],
})
export class AppRoutingModule {

}
